export enum EncryptType {
  Variables = 'VARIABLES',
  Env = 'RC',
  Jwt = 'JWT',
}
